import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'SearchSection' })((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 40,
        maxWidth: 1032,
        marginLeft: 'auto',
        marginRight: 'auto',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            gap: 32
        }
    },
    input: {
        maxWidth: 854
    }
}));
